module.exports = __webpack_public_path__ + "static/media/vip-ticket.f02a2cb6.png";